<template>
    <div>
        <div class="modal-overlay" v-if="contact_details" @click="closeModal"></div>
        <div class="right-panel" :class="{ active: true }">
            <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="contact_details_loading"
                :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>

            <template v-if="contact_details">
                <!-- Contact details -->
                <div class="contact-card">
                    <div class="contact-details-top-header">
                        <button class="action-btn btn-close" @click="closeModal">
                            <img src="@/assets/icons/close_black.svg" alt="edit" />
                        </button>
                    </div>
                    <div class="contact-details-header">
                        <div class="contact-details-header-left">
                            <widgetProfile :title="`${contact_details.first_name} ${contact_details.last_name}`"
                                subtitle="" file_name="" path="" :size="80" :text_size="15" :showContent="false"
                                :whiteBorder="true" :enableRightMargin="false" class="contact-profile-image">
                            </widgetProfile>
                            <div class="contact-card-info">
                                <h3>
                                    {{ contact_details.first_name | validate }} {{ " " }}
                                    {{ contact_details.last_name | validate }}
                                </h3>
                                <h5> <img class="location-icon" src="@/assets/icons/account_overview/map-pin.svg"
                                        alt="location" /> {{ contactLocation }}</h5>
                            </div>
                        </div>
                        <div class="contact-details-header-right">
                            <div class="opt-out-badget" v-if="contact_details.optedOut">
                                <span>Opt-out</span>
                            </div>
                            <button class="action-btn edit" v-if="showContactOptions"
                                @click="updateContact(contact_details)">
                                <img src="@/assets/icons/notes/pencil.svg" alt="edit" />
                            </button>

                            <widgetDropdown v-if="showContactOptions" v-model="toggle_more_action" :right="true"
                                :hover="false" :interactive="true">
                                <button class="action-btn more">
                                    <img src="@/assets/icons/more.svg" alt="more" />
                                </button>
                                <div slot="dropdown" class="dropdown-widget right">
                                    <app-dialog title="Delete Contact"
                                        ask="Are you sure you want to delete this contact?" yesText="Delete"
                                        noText="Cancel" @onComfirm="deleteContact(contact_details)">
                                        <button class="dropdown-item">
                                            Delete
                                        </button>
                                    </app-dialog>
                                </div>
                            </widgetDropdown>
                        </div>
                    </div>


                    <div class="contact-details-body">
                        <div class="contact-detail-item">
                            <div class="contact-detail-icon">
                                <span class="contact-detail-icon-text">Phone:</span>
                            </div>
                            <div class="contact-detail-content">
                                <p>{{ contact_details.phone_alt | validate }}</p>
                            </div>
                        </div>
                        <div class="contact-detail-item">
                            <div class="contact-detail-icon">
                                <span class="contact-detail-icon-text">Email:</span>
                            </div>
                            <div class="contact-detail-content">
                                <p>{{ contact_details.email | validate }}</p>
                            </div>
                        </div>

                        <div class="contact-detail-item">
                            <div class="contact-detail-icon">
                                <span class="contact-detail-icon-text">Position:</span>
                            </div>
                            <div class="contact-detail-content">
                                <p>{{ contact_details.position | validate }}</p>
                            </div>
                        </div>

                        <div class="contact-detail-item">
                            <div class="contact-detail-icon">
                                <span class="contact-detail-icon-text">Domain:</span>
                            </div>
                            <div class="contact-detail-content">
                                <p>{{ contact_details.domain | validate }}</p>
                            </div>
                        </div>


                        <div class="contact-detail-item">
                            <div class="contact-detail-icon">
                                <span class="contact-detail-icon-text">Work Type:</span>
                            </div>
                            <div class="contact-detail-content">
                                <p class="worktype">
                                    {{ workType }}
                                </p>
                            </div>
                        </div>


                        <div class="contact-detail-item">
                            <div class="contact-detail-icon">
                                <span class="contact-detail-icon-text">Website:</span>
                            </div>
                            <div class="contact-detail-content">
                                <p>{{ contact_details.website | validate }}</p>
                            </div>
                        </div>

                        <div class="contact-detail-item"
                            v-if="contact_details.title && contact_details.contact_type == 'company_contact'">
                            <div class="contact-detail-icon">
                                <span class="contact-detail-icon-text">LIA Title:</span>
                            </div>
                            <div class="contact-detail-content">
                                <p>{{ contact_details.title | validate }}</p>
                            </div>
                        </div>


                        <div class="contact-detail-item"
                            v-if="contact_details.public_contact && contact_details.contact_type == 'company_contact'">
                            <div class="contact-detail-icon">
                                <span class="contact-detail-icon-text">Student contact:</span>
                            </div>
                            <div class="contact-detail-content">
                                <p>{{ contact_details.public_contact | validate }}</p>
                            </div>
                        </div>

                        <div class="contact-detail-item" v-if="contact_details.account">
                            <div class="contact-detail-icon">
                                <span class="contact-detail-icon-text">Account:</span>
                            </div>
                            <div class="contact-detail-content">
                                <widgetProfile :title="contact_details.account.name" subtitle="" file_name="" path=""
                                    :size="19" :text_size="9">
                                </widgetProfile>
                            </div>
                        </div>

                        <div class="contact-detail-item contact-dis-col">
                            <div class="contact-detail-icon">
                                <span class="contact-detail-icon-text">Schools</span>
                            </div>
                            <div class="contact-detail-content">
                                <div class="tags" v-if="contact_details.schools">
                                    <widgetTagItem v-for="(school, index) in contact_details.schools" :key="index"
                                        :value="school.name" :canClose="false">
                                    </widgetTagItem>
                                </div>
                            </div>
                        </div>

                        <div class="contact-detail-item contact-dis-col"
                            v-if="contact_details.contact_type == 'account_contact'">
                            <div class="contact-detail-icon">
                                <span class="contact-detail-icon-text">Contact Types</span>
                            </div>
                            <div class="contact-detail-content">
                                <div class="tags" v-if="contact_details.roles">
                                    <widgetTagItem v-for="(tag, index) in contact_details.roles" :key="index"
                                        :value="tag.name" :canClose="false">
                                    </widgetTagItem>
                                </div>
                            </div>
                        </div>



                        <div class="contact-detail-item contact-dis-col">
                            <div class="contact-detail-icon">
                                <span class="contact-detail-icon-text">Contact Owners</span>
                            </div>
                            <div class="contact-detail-content">
                                <div class="owners-widget" v-if="contact_details.owners">
                                    <div class="owner" v-for="(owner, index) in contact_details.owners">
                                        <widgetProfile :key="index" :title="owner.first_name + ' ' + owner.last_name"
                                            subtitle="" file_name="" :size="19" :text_size="9" path="">
                                        </widgetProfile>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="contact-detail-item contact-dis-col">
                            <div class="contact-detail-icon">
                                <span class="contact-detail-icon-text">Tags</span>
                            </div>
                            <div class="contact-detail-content">
                                <div class="tags" v-if="contact_details.tags">
                                    <widgetTagItem v-for="(tag, index) in contact_details.tags" :key="index"
                                        :value="tag.name" :canClose="false">
                                    </widgetTagItem>
                                </div>
                            </div>
                        </div>

                        <div class="contact-detail-item contact-dis-col">
                            <div class="contact-detail-icon">
                                <span class="contact-detail-icon-text">Description</span>
                            </div>
                            <div class="contact-detail-content">
                                <p class="comment">
                                    {{ contact_details.description | validate }}
                                </p>
                            </div>
                        </div>


                    </div>

                    <div class="contact-details-footer">
                        <!-- Contact task -->
                        <div class="widget-container" v-if="contact_details.tasks && contact_details.tasks.length > 0">
                            <div class="container-header">
                                <h3>Tasks</h3>
                                <button class="btn-view-all" @click="$router.push({ name: 'task' })">
                                    View All
                                </button>
                            </div>
                            <div class="widget-body">
                                <div v-for="(task, i) in contact_details.tasks.slice(0, 5)" :key="i" class="card">
                                    <div class="card-header">
                                        <div class="title">
                                            {{ task.name | validate }}
                                        </div>
                                        <div class="card-type">
                                            <label :style="{ color: getColor(task.type) }">{{
                                                task.type | validate
                                            }}</label>
                                            <div :style="{ 'background-color': getColor(task.type) }" class="type-box">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="compang-widget">
                                        <span class="company-name" v-if="task.account">{{
                                            task.account.name | validate
                                        }}</span>
                                    </div>
                                    <div class="members">
                                        <div class="member" v-for="(member, index) in task.assignees" :key="index">
                                            <assingProfileToolTip :member="member">
                                                <img v-if="member.profile_picture" :src="$fullUrl(
                                                    'images/profiles/' + member.profile_picture
                                                )
                                                    " :class="{ override: index > 0 }" />
                                                <img v-else :class="{ override: index > 0 }"
                                                    src="@/assets/avatar.png" />
                                            </assingProfileToolTip>
                                            <span v-if="task.assignees.length == 1" class="name">{{
                                                (member.first_name + " " + member.last_name) | validate
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="due-date" v-if="task.due_date">
                                        {{
                                            moment(task.due_date).format("ddd, DD MMM YYYY")
                                            | validate
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Contact lead -->
                        <div class="widget-container" v-if="contact_details.leads && contact_details.leads.length > 0">
                            <div class="container-header">
                                <h3>Leads</h3>
                                <button class="btn-view-all" @click="$router.push({ name: 'leads' })">
                                    View All
                                </button>
                            </div>
                            <div class="widget-body">
                                <div v-for="(lead, i) in contact_details.leads.slice(0, 5)" :key="i" class="lead-card">
                                    <div class="card-header"></div>
                                    <div class="title-widget">
                                        <span class="lead-name">{{ lead.name | validate }}</span>
                                    </div>
                                    <div class="compang-widget" v-if="lead.account">
                                        <span class="company-name">
                                            {{ lead.account.name | validate }}
                                        </span>
                                    </div>

                                    <div class="members">
                                        <div class="member" v-for="(member, index) in lead.assignees" :key="index">
                                            <assingProfileToolTip :member="member">
                                                <img v-if="member.profile_picture" :src="$fullUrl(
                                                    'images/profiles/' + member.profile_picture
                                                )
                                                    " :class="{ override: index > 0 }" />
                                                <img v-else :class="{ override: index > 0 }"
                                                    src="@/assets/avatar.png" />
                                            </assingProfileToolTip>
                                            <span v-if="lead.assignees.length == 1" class="name">{{
                                                (member.first_name + " " + member.last_name) | validate
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="price">{{ lead.value | validate }} USD</div>
                                </div>
                            </div>
                        </div>
                        <!-- Contact Lia -->
                        <div class="widget-container" v-if="contact_details.internships &&
                            contact_details.internships.length > 0
                        ">
                            <div class="container-header">
                                <h3>LIA</h3>
                                <button class="btn-view-all" @click="$router.push({ name: 'assignment' })">
                                    View All
                                </button>
                            </div>
                            <div class="widget-body">
                                <internshipItem v-for="(item, index) in contact_details.internships" :item="item"
                                    :key="index" :index="index" :class="{ active: false }" :show_option="false"
                                    :isCheckBox="false" :isInArchive="false" :fullContent="false" type="school">
                                </internshipItem>
                            </div>
                        </div>
                    </div>

                </div>


            </template>
        </div>
    </div>
</template>

<script>
import { eventBus } from "@/main";
import internshipItem from "@/views/internship/components/internship_item.vue";
export default {
    components: {
        internshipItem,
    },
    props: {
        contact_id: {
            type: [String, Number],
            default: null,
        },
        showContactOptions: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        toggle_more_action: false,
        contact_details: null,
        contact_details_loading: false,
        stickContactCard: false,
        task_types: [
            {
                name: "Task",
                color: "#0884AF",
            },
            {
                name: "Follow up",
                color: "#1BA5A4",
            },
            {
                name: "Call",
                color: "#FFC273",
            },
            {
                name: "Mail",
                color: "#9FD076",
            },
            {
                name: "Meeting",
                color: "#ACAF5C",
            },
            {
                name: "Other",
                color: "#ED6400",
            },
        ],
    }),
    watch: {
        contact_id(newVal) {
            if (newVal) {
                this.getContantDetails(newVal);
            }
        },
    },
    mounted() {
        let vm = this;
        if (vm.contact_id) {
            vm.getContantDetails(vm.contact_id);
        }
    },
    computed: {
        contactLocation() {
            let vm = this;
            let full_location = "";
            if (vm.contact_details && Array.isArray(vm.contact_details.location)) {
                vm.contact_details.location.forEach((location, index) => {
                    full_location += index == 0 ? location : ", " + location;
                });
            }
            return full_location;
        },
        workType() {
            let vm = this;
            if (vm.contact_details.worktype == 'onsite') {
                return 'On site';
            } else if (vm.contact_details.worktype == 'remote') {
                return 'Remote';
            } else if (vm.contact_details.worktype == 'hybrid') {
                return 'Hybrid';
            } else if (vm.contact_details.worktype == 'flexible') {
                return 'Flexible';
            }
            return '';
        },
    },
    methods: {
        deleteContact(contact) {
            let vm = this;
            vm.$emit("delete", contact.id);
        },
        updateContact(contact) {
            let vm = this;
            vm.$emit("update", contact);
        },
        getColor(val) {
            let vm = this;
            let color = "";
            vm.task_types.forEach((item) => {
                if (item.name == val) {
                    color = item.color;
                }
            });
            return color;
        },
        getContantDetails(id) {
            let vm = this;
            vm.contact_details_loading = true;
            vm.$store
                .dispatch("ACCOUNT_CONTACT_DETAILS", {
                    id: id,
                })
                .then((responce) => {
                    vm.contact_details_loading = false;
                    vm.contact_details = responce.data;
                })
                .catch((error) => {
                    vm.contact_details_loading = false;
                    vm.$notify({
                        group: "status",
                        title: "Message",
                        text: "Something went wrong",
                        type: "warn",
                        duration: 3000,
                    });
                    console.error({ error });
                });
        },
        closeModal() {
            this.contact_details = null;
            this.$emit("close");
        },
    },
    watch: {
    },
};
</script>

<style lang="scss" scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.0);
    z-index: 999999;
}

.right-panel {
    overflow-y: auto;
    padding-bottom: 100px;
    width: 0px;
    position: fixed;
    top: 59px;
    bottom: 62px;
    right: -605px;
    border-radius: 10px;
    background: #fff;
    transition: all 0.3s ease-in-out;
    z-index: 9999999;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

    &.active {
        width: 605px;
        right: 10px;
        transition: all 1s ease-in-out;
    }

    @media (min-width: 300px) and (max-width: 630px) {
        position: fixed;
        top: 0px;
        left: 0px;
        bottom: 0px;
        right: 0px;
        z-index: 999999;
    }

    .contact-card {
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 10px;
        padding: 5px;
        background: #fff;
        transition: all 0.3s ease-in-out;

        .contact-details-top-header {
            display: flex;
            justify-content: flex-end;
            width: 100%;
            padding: 10px 10px;
        }

        .contact-details-header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            padding: 0px 30px;

            .contact-details-header-left {
                display: flex;
                align-items: center;
                gap: 10px;

                .contact-profile-image {
                    transition: all 0.3s ease-in-out;
                }

                .contact-card-info {
                    display: flex;
                    flex-direction: column;
                    transition: all 0.3s ease-in-out;

                    h3 {
                        margin: 0px;
                        font-size: 20px;
                        margin-bottom: 4px;
                    }

                    h5 {
                        margin: 0px;
                        font-size: 12px;
                        color: #646262;
                        margin-bottom: 10px;
                    }
                }

            }

            .contact-details-header-right {
                display: flex;
                align-items: center;
                gap: 10px;

                .opt-out-badget {
                    background: rgba(149, 20, 24, 1);
                    color: #fff;
                    padding: 5px 10px;
                    border-radius: 5px;
                }

                .action-btn {
                    background: none;
                    border: none;
                    cursor: pointer;
                }
            }
        }

        .contact-details-body {
            width: 100%;
            padding: 0px 30px;

            .contact-detail-item {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 10px;

                &.contact-dis-col {
                    flex-direction: column;
                    align-items: flex-start;
                }

                .contact-detail-icon {
                    display: flex;
                    align-items: center;
                    gap: 5px;

                    img {
                        width: 20px;
                        height: 20px;
                    }

                    .contact-detail-icon-text {
                        font-size: 13px;
                        color: #8E8E8E;
                    }
                }

                .contact-detail-content {
                    p {
                        margin: 0px;
                        font-size: 12px;
                        color: #646262;
                    }

                    p.comment {
                        font-size: 12px;
                        text-align: justify;
                    }



                    .tags {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        margin-bottom: 10px;
                        width: 100%;
                    }

                    .owners-widget {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        margin-bottom: 10px;
                        width: 100%;
                        gap: 10px;

                        .owner {
                            display: flex;
                            background: #f5f5f5;
                            padding: 5px;
                            border-radius: 5px;
                        }
                    }

                    .worktype {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        width: 100%;
                        color: #0884af;
                    }
                }
            }


        }

        .contact-details-footer {
            padding: 0px 30px;
            width: 100%;

            .widget-container {
                background: #ffffff;
                padding: 0px;
                margin-bottom: 0px;
                border-radius: 5px;

                .container-header {
                    display: flex;
                    justify-content: space-between;
                    padding: 4px 0px;

                    h3 {
                        font-size: 14px;
                        margin: 0px;
                    }

                    .btn-view-all {
                        color: #0884af;
                    }
                }

                .widget-body {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 10px;

                    .card {
                        width: 100%;
                        background: #f5f5f5;
                        position: relative;
                        padding: 8px 8px;
                        border-radius: 5px;
                        margin-bottom: 5px;

                        .card-header {
                            display: flex;
                            justify-content: space-between;
                            margin-bottom: 5px;
                            width: 100%;

                            .title {
                                font-size: 12px !important;
                                color: #000;
                                overflow: hidden;
                                text-decoration: none;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                width: 99%;
                            }

                            .card-type {
                                display: flex;
                                align-items: center;
                                justify-content: flex-end;

                                label {
                                    font-size: 10px;
                                    white-space: nowrap;
                                    text-align: right;
                                }

                                .type-box {
                                    height: 15px;
                                    width: 15px;
                                    border-radius: 2px;
                                    margin-left: 5px;
                                }
                            }
                        }

                        .compang-widget {
                            display: flex;
                            flex-direction: column;
                            padding-right: 20px;

                            .company-name {
                                color: #707070;
                                font-size: 12px;
                                margin-bottom: 5px;
                            }

                            .company-contact {
                                display: flex;
                                align-items: center;
                                margin-bottom: 5px;

                                span {
                                    font-size: 12px;
                                    white-space: nowrap;
                                }

                                .other-contact {
                                    color: #ccc;
                                    font-size: 12px;
                                    white-space: nowrap;
                                }
                            }
                        }

                        .members {
                            display: flex;

                            .member {
                                display: flex;
                                align-items: center;

                                img {
                                    width: 20px;
                                    height: 20px;
                                    object-fit: cover;
                                    margin-right: 4px;
                                    border-radius: 50%;
                                    border: 2px solid #fff;

                                    &.override {
                                        margin-left: -10px;
                                    }
                                }

                                .name {
                                    background: #06a1a11f;
                                    padding: 2px 5px;
                                    border-radius: 15px;
                                    font-size: 11px;
                                    color: #04a5a5;
                                    display: block;
                                }
                            }
                        }

                        .due-date {
                            position: absolute;
                            bottom: 18px;
                            right: 15px;
                            font-size: 10px;
                            display: none;
                        }

                        &.hold {
                            border: solid#04a5a5 1px;
                            border-radius: 5px;
                        }

                        &.invisible {
                            opacity: 0.5;
                        }
                    }

                    .lead-card {
                        width: 100%;
                        background: #f5f5f5;
                        position: relative;
                        padding: 15px 15px;
                        cursor: pointer;
                        border-radius: 5px;
                        margin-bottom: 5px;

                        &:hover {
                            .card-header {
                                .card-checkbox {
                                    display: block;
                                }
                            }
                        }

                        .card-header {
                            display: flex;
                            justify-content: flex-end;
                            position: absolute;
                            right: 2px;
                            top: 8px;

                            .card-checkbox:checked {
                                display: block;
                            }

                            .card-checkbox {
                                display: none;
                            }
                        }

                        .title-widget {
                            margin-bottom: 5px;

                            .lead-name {
                                font-size: 12px !important;
                                color: #000;
                                overflow: hidden;
                                text-decoration: none;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                width: 115px;
                            }
                        }

                        .compang-widget {
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;

                            .company-name {
                                color: #0884af;
                                font-size: 12px;
                            }

                            .company-contact {
                                display: flex;
                                align-items: center;
                                margin-bottom: 5px;

                                span {
                                    font-size: 12px;
                                    white-space: nowrap;
                                }

                                .other-contact {
                                    color: #ccc;
                                    font-size: 12px;
                                    white-space: nowrap;
                                }
                            }
                        }

                        .members {
                            margin-top: 5px;
                            display: flex;

                            .member {
                                display: flex;
                                align-items: center;

                                img {
                                    width: 20px;
                                    height: 20px;
                                    object-fit: cover;
                                    margin-right: 4px;
                                    border-radius: 50%;
                                    border: 2px solid #fff;

                                    &.override {
                                        margin-left: -10px;
                                    }
                                }

                                .name {
                                    background: #06a1a11f;
                                    padding: 2px 5px;
                                    border-radius: 15px;
                                    font-size: 11px;
                                    color: #04a5a5;
                                    display: block;
                                }
                            }
                        }

                        .price {
                            color: rgb(134, 134, 134);
                            position: absolute;
                            bottom: 18px;
                            right: 15px;
                            font-size: 10px;
                        }

                        .attachment {
                            width: 100%;
                            padding: 0px 10px;

                            img {
                                width: 100%;
                                height: 70px;
                                object-fit: cover;
                                border-radius: 20px;
                            }
                        }
                    }
                }
            }

            .widget-container {
                background: #ffffff;
                padding: 0px 0px;
                margin-bottom: 0px;
                border-radius: 5px;

                .container-header {
                    display: flex;
                    justify-content: space-between;
                    padding: 4px 0px;

                    h3 {
                        font-size: 17px;
                        margin: 0px;
                    }

                    .btn-view-all {
                        color: #0884af;
                    }
                }

                .widget-body {
                    .card {
                        width: 100%;
                        background: #f5f5f5;
                        position: relative;
                        padding: 8px 8px;
                        border-radius: 10px;
                        margin-bottom: 10px;
                        min-height: 72px;

                        .card-header {
                            display: flex;
                            justify-content: space-between;
                            margin-bottom: 5px;
                            width: 100%;

                            .title {
                                font-size: 12px !important;
                                color: #000;
                                overflow: hidden;
                                text-decoration: none;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                width: 115px;
                            }

                            .card-type {
                                display: flex;
                                align-items: center;
                                justify-content: flex-end;

                                label {
                                    font-size: 10px;
                                    white-space: nowrap;
                                    text-align: right;
                                }

                                .type-box {
                                    height: 15px;
                                    width: 15px;
                                    border-radius: 2px;
                                    margin-left: 5px;
                                }
                            }
                        }

                        .compang-widget {
                            display: flex;
                            flex-direction: column;
                            padding-right: 20px;

                            .company-name {
                                color: #707070;
                                margin-bottom: 5px;
                            }

                            .company-contact {
                                display: flex;
                                align-items: center;
                                margin-bottom: 5px;

                                span {
                                    font-size: 12px;
                                    white-space: nowrap;
                                }

                                .other-contact {
                                    color: #ccc;
                                    font-size: 12px;
                                    white-space: nowrap;
                                }
                            }
                        }

                        .members {
                            display: flex;

                            .member {
                                display: flex;
                                align-items: center;

                                img {
                                    width: 20px;
                                    height: 20px;
                                    object-fit: cover;
                                    margin-right: 4px;
                                    border-radius: 50%;
                                    border: 2px solid #fff;

                                    &.override {
                                        margin-left: -10px;
                                    }
                                }

                                .name {
                                    background: #06a1a11f;
                                    padding: 2px 5px;
                                    border-radius: 15px;
                                    font-size: 11px;
                                    color: #04a5a5;
                                    display: block;
                                }
                            }
                        }

                        .due-date {
                            position: absolute;
                            bottom: 10px;
                            right: 15px;
                            font-size: 10px;
                        }

                        &.hold {
                            border: solid#04a5a5 1px;
                            border-radius: 5px;
                        }

                        &.invisible {
                            opacity: 0.5;
                        }
                    }

                    .lead-card {
                        width: 100%;
                        background: #f5f5f5;
                        position: relative;
                        padding: 15px 15px;
                        cursor: pointer;
                        border-radius: 10px;
                        margin-bottom: 10px;

                        &:hover {
                            .card-header {
                                .card-checkbox {
                                    display: block;
                                }
                            }
                        }

                        .card-header {
                            display: flex;
                            justify-content: flex-end;
                            position: absolute;
                            right: 2px;
                            top: 8px;

                            .card-checkbox:checked {
                                display: block;
                            }

                            .card-checkbox {
                                display: none;
                            }
                        }

                        .title-widget {
                            margin-bottom: 5px;

                            .lead-name {
                                font-size: 12px;
                                color: #000;
                                overflow: hidden;
                                text-decoration: none;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                width: 115px;
                            }
                        }

                        .compang-widget {
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;

                            .company-name {
                                color: #0884af;
                            }

                            .company-contact {
                                display: flex;
                                align-items: center;
                                margin-bottom: 5px;

                                span {
                                    font-size: 12px;
                                    white-space: nowrap;
                                }

                                .other-contact {
                                    color: #ccc;
                                    font-size: 12px;
                                    white-space: nowrap;
                                }
                            }
                        }

                        .members {
                            margin-top: 5px;
                            display: flex;

                            .member {
                                display: flex;
                                align-items: center;

                                img {
                                    width: 20px;
                                    height: 20px;
                                    object-fit: cover;
                                    margin-right: 4px;
                                    border-radius: 50%;
                                    border: 2px solid #fff;

                                    &.override {
                                        margin-left: -10px;
                                    }
                                }

                                .name {
                                    background: #06a1a11f;
                                    padding: 2px 5px;
                                    border-radius: 15px;
                                    font-size: 11px;
                                    color: #04a5a5;
                                    display: block;
                                }
                            }
                        }

                        .price {
                            color: rgb(134, 134, 134);
                            position: absolute;
                            bottom: 18px;
                            right: 15px;
                            font-size: 10px;
                        }

                        .attachment {
                            width: 100%;
                            padding: 0px 10px;

                            img {
                                width: 100%;
                                height: 70px;
                                object-fit: cover;
                                border-radius: 20px;
                            }
                        }
                    }

                    ul.assignments-items {
                        list-style: none;
                        padding-left: 0px;
                        margin: 0px;

                        @media (min-width: 300px) and (max-width: 630px) {
                            padding: 0px 0px;
                        }

                        .assignments-item {
                            background: #f8f8f8;
                            border-radius: 10px;
                            margin-bottom: 10px;
                            position: relative;
                            cursor: pointer;
                            border: none;

                            @media (min-width: 300px) and (max-width: 630px) {
                                padding: 0px 0px;
                            }

                            &.active {
                                background: #1885ad15;
                            }

                            .inter-check {
                                position: absolute;
                                top: 4px;
                                left: 3px;
                            }

                            .assignments-item-header {
                                display: flex;
                                align-items: center;
                                padding: 10px 14px;

                                .assignments-item-brand {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    width: 60px;
                                    height: 60px;

                                    @media (min-width: 300px) and (max-width: 630px) {
                                        width: 60px;
                                        height: 60px;
                                    }

                                    img {
                                        width: 50px;
                                        height: 50px;
                                        border-radius: 50%;
                                        object-fit: cover;

                                        @media (min-width: 300px) and (max-width: 630px) {
                                            width: 50px;
                                            height: 50px;
                                        }
                                    }
                                }

                                .content {
                                    display: flex;
                                    width: 100%;
                                    padding-right: 5px;
                                    padding-left: 10px;
                                    justify-content: space-between;
                                    align-items: flex-start;
                                    padding-top: 6px;

                                    .title-row {
                                        width: 100%;

                                        label {
                                            font-size: 18px;
                                            color: #000;
                                            margin-bottom: 3px;
                                            overflow: hidden;
                                            text-decoration: none;
                                            text-overflow: ellipsis;
                                            white-space: nowrap;
                                            width: 100%;
                                            display: block;
                                        }

                                        p.company {
                                            margin: 0px;
                                            font-size: 16px;
                                            margin-bottom: 3px;
                                            overflow: hidden;
                                            text-decoration: none;
                                            text-overflow: ellipsis;
                                            white-space: nowrap;
                                            width: 100%;
                                            display: block;
                                            color: #6c6c6c;
                                        }

                                        p.location {
                                            color: #1ba5a4;
                                            margin: 0px;
                                            margin-bottom: 3px;
                                            font-size: 14px;
                                            overflow: hidden;
                                            text-decoration: none;
                                            text-overflow: ellipsis;
                                            white-space: nowrap;
                                            width: 100%;
                                            display: block;
                                        }

                                        p.date {
                                            color: #6c6c6c;
                                            margin: 0px;
                                            margin-bottom: 3px;
                                            font-size: 14px;
                                            overflow: hidden;
                                            text-decoration: none;
                                            text-overflow: ellipsis;
                                            white-space: nowrap;
                                            width: 100%;
                                            display: block;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

        }

    }
}
</style>
